import { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../hooks/authSlice';
import { capitalizeFirstChar } from '../utils/stringManipulate';
import { useAuth } from '../hooks/useAuth';
import { Link } from "react-router";

const UserMenu = () => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef();
  const dispatch = useDispatch();

  const { 
    name, 
    email, 
    photoURL, 
    emailVerified, 
    uid,
    phoneNumber,
    user,
    logout,
    loading 
  } = useAuth();

  const toggleMenu = () => setOpen(!open);

  const handleClickOutside = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (!user) {
    console.log("No user set");
    return null;
  };

  return (
    <div className="fixed top-10 right-10 z-50" ref={menuRef}>
      <div className="relative">
        <img
          src={photoURL}
          alt="Profile"
          onClick={toggleMenu}
          className="w-12 h-12 rounded-full cursor-pointer border-2 border-gray-300 hover:ring-2 hover:ring-blue-500 transition"
        />

        {open && (
          <div className="absolute right-0 mt-2 w-64 bg-white shadow-lg rounded-lg border border-gray-200 p-4 text-sm space-y-2 z-50">
            <div className="flex items-center space-x-3">
              <div>
                <p className="font-semibold text-lg">{capitalizeFirstChar(name)}</p>
                <p className="text-gray-500">{email}</p>
              </div>
            </div>

            <Link to='/'>
              <button
                onClick={() => dispatch(logout())}
                className="w-full mt-3 bg-red-400 hover:bg-red-500 text-white py-1 px-3 rounded transition"
              >
                Logout
              </button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserMenu;